import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';

import { buttonVariants, cn } from '@cold-ambulance/shadcn';
import { SuccessIcon } from '@cold-ambulance/ui';

import { NewRequestButton } from '../../components/new-request-button.tsx';

interface OfferAcceptedState {
  documentSubmissionRequired: boolean;
  requestId: string;
  offerId: string;
}

export default function OfferAccepted() {
  const { t } = useTranslation();
  const location = useLocation();
  const state = location.state as OfferAcceptedState | null;

  // Default to documents required if no state (e.g., direct navigation)
  const documentSubmissionRequired = state?.documentSubmissionRequired ?? true;
  const requestId = state?.requestId;
  const offerId = state?.offerId;

  if (!documentSubmissionRequired && requestId && offerId) {
    return (
      <div className="page-container">
        <div className="mx-auto flex min-h-0 max-w-sm flex-1 flex-col justify-center">
          <div className="flex flex-col items-center justify-center gap-y-6">
            <SuccessIcon />
            <p className="text-center text-3xl font-semibold">
              {t('offerAccepted.offerAcceptedSuccess')}
            </p>
          </div>
          <p className="mt-4 text-center">
            {t('offerAccepted.noDocumentsRequired')}
          </p>
          <Link
            to={`/requests/${requestId}/offers/${offerId}/contract`}
            className={buttonVariants({
              variant: 'default',
              className: 'mt-16 !h-11 px-6',
            })}
          >
            {t('offerAccepted.viewContractStatus')}
          </Link>
          <div className="mb-4"></div>
          <Link
            to="/"
            className={buttonVariants({
              variant: 'outline',
              className: cn('!h-11 px-6', 'text-primary bg-transparent'),
            })}
          >
            {t('requests.goToDashboard')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="mx-auto flex min-h-0 max-w-sm flex-1 flex-col justify-center">
        <div className="flex flex-col items-center justify-center gap-y-6">
          <SuccessIcon />
          <p className="text-center text-3xl font-semibold">
            {t('offerAccepted.documentsSentSuccess')}
          </p>
        </div>
        <p className="mt-4 text-center">
          {t('offerAccepted.documentsSentDescription')}
        </p>
        <Link
          to="/"
          className={buttonVariants({
            variant: 'default',
            className: 'mt-16 !h-11 px-6',
          })}
        >
          {t('requests.goToDashboard')}
        </Link>
        <div className="mb-4"></div>
        <NewRequestButton variant="outline" className="bg-transparent text-primary" />
      </div>
    </div>
  );
}
